import { LiveBoard } from './pages/LiveBoard';
import './styles.css';

export default function App() {
  return <LiveBoard />;
}
